// export const USER_API_END_POINT = "http://localhost:8000/api/v1/user";
// export const JOB_API_END_POINT = "http://localhost:8000/api/v1/job";
// export const APPLICATION_API_END_POINT = "http://localhost:8000/api/v1/application";
// export const COMPANY_API_END_POINT = "http://localhost:8000/api/v1/company";
export const USER_API_END_POINT = "https://job-portal-7i8l.onrender.com/api/v1/user";
export const JOB_API_END_POINT = "https://job-portal-7i8l.onrender.com/api/v1/job";
export const APPLICATION_API_END_POINT = "https://job-portal-7i8l.onrender.com/api/v1/application";
export const COMPANY_API_END_POINT = "https://job-portal-7i8l.onrender.com/api/v1/company";